(function () {
  var GAP = 12;

  function stack() {
    var el = document.querySelector('[data-stack]');
    if (!el) return;

    // Arming happens inline, before first paint. If it did not run, the fan is
    // already on screen and there is nothing to assemble.
    if (!el.classList.contains('is-armed')) return;

    // No observer means no trigger, so show the finished fan rather than
    // leaving the cards hidden forever.
    if (!window.IntersectionObserver) {
      el.classList.add('is-in');
      return;
    }

    var seen = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          // Assemble once. Replaying on every scroll past would be noise.
          seen.unobserve(entry.target);
        });
      },
      { threshold: 0.4 },
    );

    seen.observe(el);
  }

  function init() {
    stack();

    var float = document.querySelector('.be-float');
    if (!float) return;

    var rest = parseInt(float.dataset.rest, 10);
    if (isNaN(rest)) rest = 24;

    var watching = false;

    function place() {
      var bar = document.querySelector('.sticky-atc');
      var lift = rest;

      // offsetHeight is 0 when the bar is display:none, which is how the theme
      // hides it above 749px, so desktop falls through to the resting offset.
      // `active-popup` force-hides the bar while leaving is-visible set, so it
      // has to be checked separately or the button would stay lifted.
      if (
        bar &&
        bar.classList.contains('is-visible') &&
        bar.offsetHeight > 0 &&
        !document.body.hasAttribute('active-popup')
      ) {
        lift = bar.offsetHeight + GAP;
      }

      float.style.setProperty('--be-offset', Math.round(lift) + 'px');
      watch(bar);
    }

    // The bar is painted by the sticky-atc engine, so it may not exist yet on
    // first run. Attach the observer the first time we actually find it.
    function watch(bar) {
      if (watching || !bar || !window.MutationObserver) return;
      watching = true;
      new MutationObserver(place).observe(bar, {
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
      new MutationObserver(place).observe(document.body, {
        attributes: true,
        attributeFilter: ['active-popup', 'class'],
      });
    }

    place();
    window.addEventListener('resize', place);
    // Cheap safety net for the case where the engine paints the bar late and
    // nothing else has fired yet.
    window.setTimeout(place, 600);
    window.setTimeout(place, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
